// extracted by mini-css-extract-plugin
export default {"filterPill":"sEOqG___FilterPill-module__filterPill","label":"Uh3+I___FilterPill-module__label","close":"qPu0t___FilterPill-module__close"};